/* eslint-disable no-console */
import App from 'components/App';
import { STRINGS } from 'config/constants';
import { loadCookieFirst, removeCookiesWithStringPrefix } from 'cookieFirst';
import React from 'react';
import { createRoot } from 'react-dom/client';
import GitInfo from 'react-git-info/macro';
import 'styles/index.css';
import { initialiseDatadog } from 'util/datadog';
import { initialiseFreshpaint } from 'util/freshpaint';
import { setupIntercom, shutDownIntercomSession } from 'util/intercom';
import reportWebVitals from 'util/reportWebVitals';

const rootElement = document.getElementById('root') as HTMLElement;
const root = createRoot(rootElement);

export const loadAndRemoveAllConsentRequiredScripts = (
  event: CustomEvent<{ performance?: boolean; functional?: boolean }>,
): void => {
  const consent = event.detail || {};
  if (consent.performance) {
    initialiseDatadog();
    initialiseFreshpaint();
  }
  if (consent.functional) {
    setupIntercom();
  }
  if (!consent.functional) {
    shutDownIntercomSession();
    removeCookiesWithStringPrefix('intercom', null, '.awshealth.net');
  }
  if (!consent.performance) {
    removeCookiesWithStringPrefix('_dd', null, 'Strict');
  }
};

export const addCookieConsentEventListeners = (): void => {
  window.addEventListener('cf_consent', loadAndRemoveAllConsentRequiredScripts as EventListener);
  window.addEventListener('cf_consent_loaded', loadAndRemoveAllConsentRequiredScripts as EventListener);
};

if (!STRINGS.ENVIRONMENT.IS_TEST_ENV) {
  addCookieConsentEventListeners();
  loadCookieFirst();
}

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

if (STRINGS.ENVIRONMENT.IS_DEV_OR_TEST_ENV) {
  const gitInfo = GitInfo();
  console.log('VERSION INFO');
  console.log('--------------------------------------------------------');
  console.log(`BRANCH * ${gitInfo.branch}`);
  console.log(`GIT COMMIT DATE * ${new Date(gitInfo.commit.date)}`);
  console.log(`LAST MESSAGE * ${gitInfo.commit.message}`);
  console.log(`HASH * ${gitInfo.commit.hash}`);
  console.log(`DATE DEPLOYED * ${process.env.REACT_APP_DEPLOY_DATE}`);
  console.log('--------------------------------------------------------');
}
